import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App.js';
import { applyPerfLite } from './usePerfLite.js';
import './styles/tokens.css';
import './styles/card.css';
import './styles/screens.css';
import './styles/performance.css';

// Resolve perf-lite with precedence: ?fx= param > stored pref ('mafia.fx') >
// auto-detect. The same helper re-applies the class live when the user toggles
// FX at runtime (see usePerfLite.ts).
applyPerfLite();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
